import React, { Component } from 'react';
import { withRouter } from '../../withRouter';
import { getCookie, setCookie } from 'helpers/cookies'
import { connect, } from 'react-redux';
import Form from 'react-bootstrap/Form';
import promotionService from 'services/promotion.service';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { pickImage } from "helpers/webpSupport";
import NewGameImgPng from 'images/Promotions/NEW_GAME.png';
import NewGameImgWebp from 'images/Promotions/NEW_GAME.webp';
import PwfHighlightImgPng from 'images/Promotions/PWF highlight.png';
import PwfHighlightImgWebp from 'images/Promotions/PWF highlight.webp';

import styles from 'components/Modals/NewGameModal/NewGameModal.module.scss';
import tickImgPng from 'images/Promotions/Blue Tick.png'
import tickImgWebp from 'images/Promotions/Blue Tick.webp'
import envelopeImgPng from 'images/Promotions/Email Guy.png'
import envelopeImgWebp from 'images/Promotions/Email Guy.webp'
import crossPng from 'images/icons/Cross.png'
import crossWebp from 'images/icons/Cross.webp'

const NewGameImg = pickImage(NewGameImgWebp, NewGameImgPng);
const PwfHighlightImg = pickImage(PwfHighlightImgWebp, PwfHighlightImgPng);
const tickImg = pickImage(tickImgWebp, tickImgPng);
const envelopeImg = pickImage(envelopeImgWebp, envelopeImgPng);
const cross = pickImage(crossWebp, crossPng);

const shopPath = "playing-with-fire";
const discountCode = "FIRE20";
const cookieAccepted = `new-${shopPath}-accepted`;
const cookieShow = `new-${shopPath}-show`;
const cookieDontShow = `new-${shopPath}-dont-show`;
const gameCode = "playing_with_fire";
class CRMModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            enabled: true,
            show: false,
        };
    }


    componentDidMount() {
        const accepted = getCookie(cookieAccepted);
        const dontShow = getCookie(cookieDontShow);
        if (accepted) setCookie(cookieAccepted, true, 400); // keeps the cookie alive (provided they return in 400 days)
        const ownsGame = this.props.auth?.user?.games?.some(g => g.code === gameCode);
        const shouldShow = !accepted && !dontShow && !ownsGame;
        this.setState({ accepted: accepted, dontShow: dontShow, enabled: shouldShow, show: shouldShow });
    }

    buyNow = (e) => {
        if (!this.state.show) return;
        e.preventDefault();
        setCookie(cookieAccepted, true, 400);
        this.setState({ show: false });
        setTimeout(() => {
            this.setState({ enabled: false });
        }, 500);
        this.props.navigate(`/shop/${shopPath}?discountCode=${discountCode}&utm_source=website&utm_medium=banner&utm_campaign=new-game-popup`);
    }

    close = () => {
        if (!this.state.show) return;
        setCookie(cookieDontShow, true, 7);
        this.setState({ show: false });
        setTimeout(() => {
            this.setState({ enabled: false });
        }, 500);
    }

    dontShow = () => {
        setCookie(cookieDontShow, true, 30);
    }

    render() {
        return <React.Fragment>
            {this.state.enabled && window.location.pathname !== "roku" &&
                <div className={`${styles.screenOverlay} ${this.state.show && styles.show} ${this.props.styles}`} >
                    <div className={styles.screenOverlayBG}></div>
                    <div className={styles.modalContainer} >
                        <img className={styles.newGameImg} src={NewGameImg} alt="new game" />
                        <Form onSubmit={this.buyNow} className={styles.modal} >
                            <button type="button" className={styles.closeButton} onClick={this.close} >
                                <img src={cross} alt="close-button" />
                            </button>
                            <img className={styles.gameHighlightImg} src={PwfHighlightImg} alt="playing with fire" />

                            <div className={styles.textContainer} >
                                <p className={`${styles.description} ${styles.large}`} >
                                    Introducing our latest game...<br />
                                    <span className={styles.gameTitle}>Playing With Fire!</span>
                                </p>
                                <p className={styles.description} >
                                    Drop bombs, dodge fire, outsmart your friends!<br />
                                    Buy it now & bring the heat.
                                </p>
                            </div>

                            <div className={styles.signUp} >
                                <div className={styles.buttonWrapper} >
                                    <button className={`${styles.button}  ${styles.alternate}`} type="submit" >BUY NOW WITH 20% OFF!</button>
                                </div>
                            </div>

                            <div className={styles.dontShow} >
                                <a className={`${styles.link}`} onClick={this.close} >Don't show this again</a>
                            </div>
                        </Form>
                    </div>
                </div>
            }
        </React.Fragment>
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pricing: state.pricing,
    };
}

export default connect(mapStateToProps)(withRouter(CRMModal));